export enum PROVIDER_TABLE_TABS {
  ENROLLED_PATIENTS = 'ENROLLED_PATIENTS',
  UNENROLLED_PATIENTS = 'UNENROLLED_PATIENTS',
  WATCHLIST = 'WATCHLIST',
  CLINIC = 'CLINIC',
}
